import Vue from 'vue';
import querystring from 'querystring';
import * as Preguntas from '@lib/MercadoLibre/Preguntas';
import * as Articulos from '@lib/Articulos';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher, SimpleEventDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';


export class ControladorSeccion
{

    public barraLateralWidth: number = 300;
    public get BarraLateralWidth()
    {
        return this.barraLateralWidth;
    }

    public set BarraLateralWidth( x: number )
    {
        this.barraLateralWidth = x;
        this._onBarraLateralWidth.dispatch();
    }
    private _onBarraLateralWidth = new SignalDispatcher();
    public get onBarraLateralWidth() { return this._onBarraLateralWidth.asEvent(); }


    public readonly Buscador: Buscador = new Buscador();
    public Seleccionados: Pregunta[] = [];

    public seleccionada: Pregunta = null;
    public SiguientePregunta()
    {
        for ( let e of this.Buscador.Items )
        {
            if ( !e.Respuesta )
            {
                this._onSiguentePregunta.dispatch( e );
                break;
            }
        }
    }

    public get Seleccionada()
    {
        return this.seleccionada;
    }

    public set Seleccionada( x: Pregunta )
    {

        this.seleccionada = x;
        this._onSeleccionado.dispatch( x );
    }

    private _onSeleccionado = new SimpleEventDispatcher<Pregunta>();
    public get onSeleccionado() { return this._onSeleccionado.asEvent(); }

    private _onSiguentePregunta = new SimpleEventDispatcher<Pregunta>();
    public get onSiguentePregunta() { return this._onSiguentePregunta.asEvent(); }

    private _onNuevaPregunta = new SimpleEventDispatcher<Pregunta>();
    public get onNuevaPregunta() { return this._onNuevaPregunta.asEvent(); }

    private _onActualizarPregunta = new SimpleEventDispatcher<Pregunta>();
    public get onActualizarPregunta() { return this._onActualizarPregunta.asEvent(); }


    EnviarARespuesta( x: string )
    {
        this._onEnviarARespuesta.dispatch( x );
    }

    private _onEnviarARespuesta = new SimpleEventDispatcher<string>();
    public get onEnviarARespuesta() { return this._onEnviarARespuesta.asEvent(); }
    public get Socket() { return Utiles.$socket.client; }
    public SocketIniciado: boolean = false;
    Iniciar()
    {
        let self = this;
        if ( !this.SocketIniciado )
        {
            console.log( 'ee' );
            this.Socket.on( 'XWPRML300', ( x: any ) => this.NuevaPregunta( self, x ) );
        }
        this.SocketIniciado = true;
    }

    async NuevaPregunta( self: ControladorSeccion, a: any )
    {
        console.log(a );
        let m = await Pregunta.create( a.id );
        if ( m )
        {
            let existe = self.Buscador.Items.find( x => x.Id == m.Id );
            if ( existe )
            {
                this._onActualizarPregunta.dispatchAsync( m );
            } else
            {
                if ( !m.Respuesta )
                {
                    this.Buscador.Items.push( m );
                    this.Buscador.Estado = 'ok';
                }
            }

        }
        console.log( m );
    }

    public Vista: Vista = new Vista();
    private _onSeleccionados = new SignalDispatcher();
    public get onSeleccionados() { return this._onSeleccionados.asEvent(); }

    public RecargarEstadistica()
    {
        this._onRecargarEstadistica.dispatch();
    }
    private _onRecargarEstadistica = new SignalDispatcher();
    public get onRecargarEstadistica() { return this._onRecargarEstadistica.asEvent(); }
}

export class Vista
{
    public Filtros: FiltrosBase = new FiltrosBase();

    protected modo: string = 'respuestas';
    get Modo(): string { return this.modo; }
    set Modo( m: string ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }

    protected subModo: string = '';
    get SubModo(): string { return this.subModo; }
    set SubModo( m: string ) { this.subModo = m; this._onSubModo.dispatch(); }
    private _onSubModo = new SignalDispatcher();
    public get onSubModo() { return this._onSubModo.asEvent(); }
}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador
{

    public Items: Pregunta[] = [];

    public Filtros: Filtros = new Filtros( this );
    Iniciar()
    {
        this.Filtros = new Filtros( this );
    }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        this.Items.clear();
        this.Estado = 'cargando';
        Utiles.setQuery( this.Filtros.get() );
        this._onActualizar.dispatch();


        await Wait( 100 );
        let ff = this.Filtros.Obtener();
        let e = await Pregunta.find( ff );
        if ( e.Error )
            this.Estado = 'error';
        else
        {
            this.Items = e.Items;
            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';

    public Valores: Record<string, any> = {
        Estado: 2,
        Limite: 1,
        Orden: 0,
        Indice: 0,
        Cuenta: 0,
        Pagina: 1,
    };


    public get Estados() { return Preguntas.Estados.Filter; }
    public get Cuentas() { return [...CuentasMercadoLibre]; }
    public get Limites() { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }
    public get Ordenes() { return [{ Nombre: 'Descendente', Id: 'DESC' }, { Nombre: 'Ascendente', Id: 'ASC' }]; }
    public get Indices() { return [{ Nombre: 'Fecha publicación', Id: 'fecha' },]; }


    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {
        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {



            if ( this.Valores.Estado > 0 )
            {
                a.push( { Nombre: this.Estados[this.Valores.Estado].Nombre, Eliminar: () => { this.Valores.Estado = 0; this.Buscador.Buscar(); } } );
            }

            //if ( this.Valores.Cuenta  > 0)
            //{
            //    a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
            //}
        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};
        filtro.busqueda = 'S';
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                filtro.estado = this.Estados[this.Valores.Estado].Valor.map( x => x.Id ).join( ',' );
            }

            if ( this.Valores.Cuenta > 0 )
            {
                filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
            }

        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }

        if ( filtro.estado )
        {
            this.Valores.Estado = 0;
            let idx = this.Estados.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.estado );
            if ( idx > 0 ) this.Valores.Estado = idx;
        }

        if ( filtro.cuenta )
        {
            this.Valores.Cuenta = 0;
            let idx = this.Cuentas.findIndex( x => x.Id == filtro.cuenta );
            if ( idx > 0 ) this.Valores.Cuenta = idx;
        }

        if ( filtro.limit )
        {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.sort )
        {
            this.Valores.Orden = 0;
            let idx = this.Ordenes.findIndex( x => x.Id == filtro.sort );
            if ( idx > 0 ) this.Valores.Orden = idx;
        }

        if ( filtro.order )
        {
            this.Valores.Indice = 0;
            let idx = this.Indices.findIndex( x => x.Id == filtro.order );
            if ( idx > 0 ) this.Valores.Indice = idx;
        }

        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }

        if ( this.Valores.Estado > 0 )
        {
            filtro.estado = this.Estados[this.Valores.Estado].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Cuenta > 0 )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }


        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}

const Controlador = new ControladorSeccion();
export { Controlador };

